import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type WalletTransfersVars } from '../queries/walletTransfersQuery';
import type { WalletTransfers } from '../types';

export default (variables: Accessor<WalletTransfersVars | null>) =>
  createDynamicQueryResource<WalletTransfers, WalletTransfersVars>(document, variables);
